import { IKnmReasonCanceled } from 'APIPackage/CatalogsModule/interfaces/IKnmReasonCanceled';

import { IKnmCanceledReasonSelectOption } from '../interfaces/IKnmCancelledReasonsSelectOption';

export const createKnmReasonCancelledSelectOption = (reason: IKnmReasonCanceled): IKnmCanceledReasonSelectOption => ({
  ...reason,
  id: reason.id.toString(),
  label: reason.name,
  value: reason.code,
});
